import {
  COMENZAR_RECORDAR_CONTRASENA,
  EVENTO_RECORDAR_CONTRASENA_ERROR,
  EVENTO_RECORDAR_CONTRASENA_EXITO,
  RESET_ERROR_RECORDAR_CONTRASENA,
} from "../types";

const initialState = {
  resultado: null,
  error: false,
  errorMessage: null,
  loading: false,
};

function recordarContrasenaReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_ERROR_RECORDAR_CONTRASENA:
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
        resultado: null,
      };
    case COMENZAR_RECORDAR_CONTRASENA:
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
      };
    case EVENTO_RECORDAR_CONTRASENA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errorMessage: action.payload.message,
      };
    case EVENTO_RECORDAR_CONTRASENA_EXITO:
      return {
        ...state,
        loading: false,
        user: null,
        error: null,
        resultado: action.payload,
      };
    default:
      return state;
  }
}

export default recordarContrasenaReducer;
